(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blocksy-about-us"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const accordionItems = document.querySelectorAll('.blocksy-accordion-item');
    const blockContents = document.querySelectorAll('.blocksy-block-content');
    const firstAccordion = accordionItems[0];
    const firstContent = blockContents[0];

    accordionItems.forEach((item) => {
      const header = item.querySelector('.blocksy-accordion-header');
      const content = item.querySelector('.blocksy-accordion-content');

      header.addEventListener('click', () => {
        const id = item.dataset.block;
        const isActive = item.classList.contains('active');

        accordionItems.forEach((i) => {
          i.classList.remove('active');
          const c = i.querySelector('.blocksy-accordion-content');
          if (c) c.style.maxHeight = null;
        });

        blockContents.forEach((c) => c.classList.remove('active'));

        if (!isActive) {
          item.classList.add('active');
          const contentHeight = content.scrollHeight;

          if (contentHeight > 180) {
            content.style.maxHeight = '180px';
            content.style.overflowY = 'auto';
          } else {
            content.style.maxHeight = contentHeight + 'px';
            content.style.overflowY = 'hidden';
          }

          const leftContent = document.querySelector(`.blocksy-block-content[data-block="${id}"]`);
          if (leftContent) leftContent.classList.add('active');
        } else {
          if (firstAccordion && firstContent) {
            firstAccordion.classList.add('active');
            const firstAccContent = firstAccordion.querySelector('.blocksy-accordion-content');
            const firstHeight = firstAccContent.scrollHeight;

            if (firstHeight > 180) {
              firstAccContent.style.maxHeight = '180px';
              firstAccContent.style.overflowY = 'auto';
            } else {
              firstAccContent.style.maxHeight = firstHeight + 'px';
              firstAccContent.style.overflowY = 'hidden';
            }

            firstContent.classList.add('active');
          }
        }
      });
    });

    if (firstAccordion) {
      const firstAccContent = firstAccordion.querySelector('.blocksy-accordion-content');
      const firstHeight = firstAccContent.scrollHeight;

      if (firstHeight > 180) {
        firstAccContent.style.maxHeight = '180px';
        firstAccContent.style.overflowY = 'auto';
      } else {
        firstAccContent.style.maxHeight = firstHeight + 'px';
        firstAccContent.style.overflowY = 'hidden';
      }
    }
  });

  // For animation
  document.addEventListener('DOMContentLoaded', function () {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      mirror: true,
    });

    // Optional: refresh in case of Swiper or dynamic content
    setTimeout(function () {
      if (window.AOS) AOS.refresh();
    }, 500);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
